import {
	REQUEST_INVOICE_FORM_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

import requestDropEventInvoice from 'root/src/client/logic/invoice/thunks/requestDropEventInvoice'

export default {
	[REQUEST_INVOICE_FORM_MODULE_ID]: [
		{
			action: requestDropEventInvoice,
		},
	],
}
